import React from 'react';
import mountReactApp from '../src/mount-react-app';
import {routes, reducers} from '../src';

// import {defaultTheme} from '../verticals/goibibo/src/stories/theme/buildTheme';
// import {GlobalStyles} from '../verticals/goibibo/src/stories/styles/style';

function renderApp() {
  const initialState = window.__initial_state__;
  initialState.common.startDate.date = new Date(initialState.common.startDate.date);
  initialState.common.endDate.date = new Date(initialState.common.endDate.date);
  mountReactApp({
    routes,
    reducers,
    initialState
    // pass these if you have a different theme and global styles
    // theme: defaultTheme,
    // style: <GlobalStyles />,
  });
}

renderApp();

// if (module.hot) {
//   module.hot.accept('cars-dweb', () => renderApp());
// }